import { render, staticRenderFns } from "./liability_insurance.vue?vue&type=template&id=de81ffc2&scoped=true&"
import script from "./liability_insurance.vue?vue&type=script&lang=js&"
export * from "./liability_insurance.vue?vue&type=script&lang=js&"
import style0 from "./liability_insurance.vue?vue&type=style&index=0&id=de81ffc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de81ffc2",
  null
  
)

export default component.exports